import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import ReaperContent from '../components/Reaper/ReaperContent/ReaperContent'
import ReaperHero from '../components/Reaper/ReaperHero/ReaperHero'

const Reaper = ({ data }) => {
  const postNode = {
    title: `REAPER - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="reaper" customTitle />
      <Helmet>
        <title>{`REAPER - ${config.siteTitle}`}</title>
      </Helmet>
      <ReaperHero />
      <ReaperContent />
    </Layout>
  )
}

export default Reaper
